/**
 * Frontend-specific time utilities.
 *
 * For standard time utilities, import directly from @breakout/shared/utils/time
 */

/**
 * Normalize a timestamp to milliseconds, auto-detecting if it's seconds or milliseconds.
 * Timestamps < 1_000_000_000_000 are assumed to be seconds (before year ~2001 in ms).
 *
 * Used internally by formatShortDate - prefer explicit secToMs() for new code.
 */
function normalizeToMs(value: number | undefined | null): number | null {
	if (value === undefined || value === null || value === 0) {
		return null
	}
	// If less than year ~2001 in milliseconds, it's likely seconds
	return value < 1_000_000_000_000 ? value * 1000 : value
}

/**
 * Format a timestamp as a short date string (e.g., "Jan 5").
 * Auto-detects if input is seconds or milliseconds.
 */
export function formatShortDate(timestamp: number): string {
	const ms = normalizeToMs(timestamp)
	if (ms === null || Number.isNaN(ms)) {
		return "—"
	}
	const date = new Date(ms)
	if (Number.isNaN(date.getTime())) {
		return "—"
	}
	return date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
	})
}
